<template>
  <div>
    <v-date-picker
      ref="datePickerRef"
      v-bind="[$attrs, baseOptions]"
      v-resize="onResize"
      :class="$style['date-picker']"
      @input="$emit('input', $event)"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
    />

    <div v-if="!hideDetails && errorMessages.length > 0" class="mt-1 v-text-field__details">
      <div class="v-messages theme--light error--text" role="alert">
        <div class="v-messages__wrapper">
          <div class="v-messages__message">{{ errorMessages[0] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { ReactiveRefs } from 'vue-reactive-refs'

Vue.use(ReactiveRefs)

export default {
  name: 'BaseDatepicker',
  refs: ['datePickerRef'],
  props: {
    errorMessages: {
      type: Array,
      default: () => [],
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sizes: {
        datePickerWidth: 0,
        windowWidth: 0,
      },
    }
  },
  computed: {
    shouldUseBaseOptions() {
      return (
        this.sizes.windowWidth < 600 ||
        (this.sizes.windowWidth >= 600 && this.sizes.datePickerWidth < 460)
      )
    },
    baseOptions() {
      return {
        ...(this.shouldUseBaseOptions && { landscape: false, fullWidth: true }),
      }
    },
  },
  methods: {
    onResize() {
      this.sizes = {
        datePickerWidth: this.$refs.datePickerRef.$el.offsetWidth,
        windowWidth: window.innerWidth,
      }
    },
  },
}
</script>

<style lang="scss" module>
.date-picker {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    max-width: 39rem;
  }
}
</style>
